import { render, staticRenderFns } from "./SortPanel.vue?vue&type=template&id=09295582&scoped=true&"
import script from "./SortPanel.vue?vue&type=script&lang=ts&"
export * from "./SortPanel.vue?vue&type=script&lang=ts&"
import style0 from "./SortPanel.vue?vue&type=style&index=0&id=09295582&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09295582",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
